import { logger } from "@/lib/logger";
import type { AppRouter, SupabaseBrowserClient } from "./types";

interface CreateSignUpHandlerArgs {
  supabase: SupabaseBrowserClient;
  router: AppRouter;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setFirstName: (firstName: string) => void;
  setLastName: (lastName: string) => void;
  setIsSignUp: (isSignUp: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  setSuccess: (success: string | null) => void;
}

export function createSignUpHandler(args: CreateSignUpHandlerArgs) {
  const {
    supabase,
    router,
    email,
    password,
    firstName,
    lastName,
    setEmail,
    setPassword,
    setFirstName,
    setLastName,
    setIsSignUp,
    setIsLoading,
    setError,
    setSuccess,
  } = args;

  return async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccess(null);

    try {
      // Sign up the user
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            first_name: firstName,
            last_name: lastName,
          },
        },
      });

      if (error) {
        logger.error("Sign up error", error);
        setError(error.message);
        return;
      }

      if (data.user) {
        if (data.user.email_confirmed_at) {
          setSuccess("Account created successfully! You can now sign in.");
          setIsSignUp(false);
        } else {
          setSuccess(
            "Account created successfully! Please check your email to verify your account before signing in."
          );
          // Redirect to verification page
          setTimeout(() => {
            router.push("/auth/verify-email");
          }, 2000);
        }
        setEmail("");
        setPassword("");
        setFirstName("");
        setLastName("");
      }
    } catch (err) {
      logger.error("Unexpected error", err);
      setError("An unexpected error occurred");
    } finally {
      setIsLoading(false);
    }
  };
}
